import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import {
  getFirstCoownerData,
  getQuotation,
  getIsOperatorFromSelector,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';
import {
  isPersonalDataRedesignActive,
  isPersonalDataTwoAdvantagesView,
} from 'app/shared/helpers/personalDataViewByDevice';

const firstCoownerObfuscation = {
  calculationShowCoownersNameObfuscatedMessage(initialRun?: boolean) {
    const { name = '' } = getFirstCoownerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: name,
      initialRun,
      messageKey: MessagesEnum.CoownersNameObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataRedesignActive(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner1',
        field: 'name',
      },
    });
  },
  calculationShowCoownersLastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastName = '' } = getFirstCoownerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastName,
      initialRun,
      messageKey: MessagesEnum.CoownersLastNameObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataRedesignActive(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner1',
        field: 'lastName',
      },
    });
  },
  calculationShowCoownersPeselObfuscatedMessage(initialRun?: boolean) {
    const pesel = `${getFirstCoownerData().pesel}`;
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: pesel,
      initialRun,
      messageKey: MessagesEnum.CoownersPeselObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataTwoAdvantagesView(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner1',
        field: 'peselNumber',
      },
    });
  },
  calculationShowCoownersFamilyNameObfuscatedMessage(initialRun?: boolean) {
    const { familyName } = getFirstCoownerData();

    const showObfuscatedMessage = checkIsDataObfuscated(familyName, initialRun);

    setMessageVisibility({
      key: MessagesEnum.FirstCoownerFamilyNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default firstCoownerObfuscation;
